import React, { useContext, useEffect, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import DynamicHtml from "../CommonComponent/DynamicHtml";
import DynamicCell from "../CommonComponent/DynamicCell";
import PrescriberNoteNoDetailsDisplay from "./PrescriberNoteNoDetailsDisplay";
import PrescriberNoteTableCell from "./PrescriberNoteTableCell";
import { Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import { CommonService, DynamicDataService } from "@services";
import { ConfigurationContext } from "../../../contexts/Configuration";
import { SearchContext } from "../../../contexts/Search";

const PrescriberNoteVerticalDisplay = ({
  prescriberNoteResponse,
  coverageFinderPrescriberNotesFields,
  section,
  contingentDataField,
  row,
}) => {
  const matchesMobileWidth = useMediaQuery("(max-width:1032px)");
  const { appliedConfiguration, settings } = useContext(ConfigurationContext);
  const { benefitType } = useContext(SearchContext);
  const benefitTypeId = benefitType == "Pharmacy" ? 2 : 1;
  const prescriberNoteLogic = appliedConfiguration.coverageFinderPrescriberNoteLogics.filter(
    (obj) => obj.benefitTypeId === benefitTypeId
  )[0];
  const CUSTOM_VALUE_DATAFIELD = "_dataFieldsWithCustomValue";
  const [showDataSource, setShowDataSource] = useState(false);
  useEffect(() => {
    if (settings?.findIndex((setting) => setting.settingId === 85 && setting.isEnabled === true) > -1) {
      setShowDataSource(true);
    }
  }, [settings]);
  const prescriberNoteResponseLowerCase = prescriberNoteResponse?.map((item) =>
    Object.keys(item).reduce((acc, key) => {
      acc[key.toLowerCase()] = item[key];
      return acc;
    }, {})
  )[0];
  const noteFields =
    section != null
      ? coverageFinderPrescriberNotesFields.filter((obj) => obj.prescriberNoteSectionId === section.id)
      : coverageFinderPrescriberNotesFields;

  function renderCustomValue(value) {
    return (
      <div
        className={showDataSource ? "norstella-cf-dataSource" : "norstella-cf-customValue"}
        dangerouslySetInnerHTML={{ __html: CommonService.sanitizeHTML(CommonService.htmlDecode(value ?? "")) }}
      />
    );
  }

  const renderDynamicCellData = function (field) {
    if (field.coverageContingentData) {
      const isCustomValue =
        row[CUSTOM_VALUE_DATAFIELD]?.split(",")?.findIndex((item) => item === contingentDataField.toLowerCase()) > -1;
      const { rowValue, iconPath, displayPrefix, altText } = DynamicDataService.extractDynamicRowData(
        row[contingentDataField]
      );
      if (isCustomValue) return renderCustomValue(rowValue);

      return <DynamicCell rowValue={rowValue} iconPath={iconPath} displayPrefix={displayPrefix} altText={altText} />;
    } else if (field.status) {
      const status = row["Status"] ?? row["majority_Status"] ?? "";
      return status;
    } else {
      return "";
    }
  };

  const sectionFieldDataExists = (field) => {
    if (prescriberNoteResponseLowerCase && CommonService.objectHasProperty(prescriberNoteResponseLowerCase, field.dataField.toLowerCase())) {
          return (
            prescriberNoteResponseLowerCase[field.dataField.toLowerCase()] !== "" &&
            prescriberNoteResponseLowerCase[field.dataField.toLowerCase()] !== null &&
            prescriberNoteResponseLowerCase[field.dataField.toLowerCase()] !== undefined
          );
        } else {
          return (
            row[field.dataField] !== "" &&
            row[field.dataField] !== null &&
            row[field.dataField] !== undefined
          );
        }
  };

  const showSectionField = (field, checkSectionFieldLogic, hideSectionFieldIfEmpty) => {
    return (
      sectionFieldDataExists(field) ||
      (checkSectionFieldLogic &&
        prescriberNoteLogic?.hideSectionFieldIfNoData?.toLowerCase() === hideSectionFieldIfEmpty) ||
      field.coverageContingentData ||
      field.status
    );
  };

  const getTableCellData = (field, subIndex) => {
    if (field.coverageContingentData || field.status) {
      return renderDynamicCellData(field);
    } else if (sectionFieldDataExists(field)) {
      return (
        <PrescriberNoteTableCell
          field={field}
          prescriberNoteResponseLowerCase={prescriberNoteResponseLowerCase}
          resultRow={row}
          cssClassName={
            field.dataField.toLowerCase() == "lineoftherapy"
              ? "norstella-cf-lineNoteTitle"
              : `norstella-cf-verticalNoteValue norstella-cf-verticalNoteValue${subIndex}`
          }
        />
      );
    } else {
      return <PrescriberNoteNoDetailsDisplay isSectionField={true} />;
    }
  };

  if (!noteFields || noteFields.length === 0) {
    return <PrescriberNoteNoDetailsDisplay isSectionField={false} />;
  }
  return (
    <TableContainer part="cfVerticalTableContainer" className="norstella-cf-verticalTableContainer">
      <Table part="cfVerticalNoteTable" className="norstella-cf-verticalNoteTable">
        <TableBody part="cfVerticalNoteTableBody" className="norstella-cf-verticalNoteTableBody">
          {noteFields.some((field) => showSectionField(field, true, "no")) ? (
            noteFields.map(
              (field, subIndex) =>
                showSectionField(field, true, "no") && (
                  <TableRow
                    part="cfNoteVerticalTableRow"
                    className={`norstella-cf-noteVerticalTableRow norstella-cf-noteVerticalTableRow${subIndex}`}
                    key={field.id}
                  >
                    {!matchesMobileWidth && (
                      <>
                        <TableCell
                          className={`norstella-cf-verticalTableNoteCellTitle norstella-cf-verticalTableNoteCellTitle${subIndex}`}
                          part="cfVerticalTableNoteCellTitle"
                          key={`${field.id}-label`}
                          component={subIndex === 0 ? "th" : "td"}
                          scope={subIndex === 0 ? "row" : ""}
                          style={{ width: "30%" }}
                        >
                          <DynamicHtml
                            part="cfVerticalNoteTitleLabel"
                            className={`norstella-cf-verticalNoteTitle norstella-cf-verticalNoteTitle${subIndex}`}
                            input={field.title}
                            type="label"
                          />
                        </TableCell>
                        <TableCell
                          className={`norstella-cf-verticalTableNoteCellContent norstella-cf-verticalTableNoteCellContent${subIndex}`}
                          part="cfVerticalTableNoteCellContent"
                          key={`${field.id}-content`}
                          component={subIndex === 0 ? "th" : "td"}
                          scope={subIndex === 0 ? "row" : ""}
                          style={{ width: "70%" }}
                        >
                          {getTableCellData(field, subIndex)}
                        </TableCell>
                      </>
                    )}
                    {matchesMobileWidth && (
                      <TableCell
                        part="cfNoteBodyCell"
                        className={`norstella-cf-verticalTableNoteCellContent norstella-cf-verticalTableNoteCellContent${subIndex}`}
                        key={field.id}
                        component={subIndex === 0 ? "th" : "td"}
                        scope={subIndex === 0 ? "row" : ""}
                      >
                        <DynamicHtml
                          part="cfVerticalNoteTitleLabel"
                          className={`norstella-cf-verticalNoteTitle norstella-cf-verticalNoteTitle${subIndex}`}
                          input={field.title}
                          type="label"
                        />
                        {getTableCellData(field, subIndex)}
                      </TableCell>
                    )}
                  </TableRow>
                )
            )
          ) : (
            <TableRow part="cfNoteVerticalTableRow" className="norstella-cf-noteVerticalTableRow">
              <TableCell
                colSpan={matchesMobileWidth ? 2 : 3}
                style={{ textAlign: "center" }}
                className="norstella-cf-noteVerticalNoDetails"
                part="cfNoteVerticalNoDetails"
              >
                <PrescriberNoteNoDetailsDisplay isSectionField={false} />
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PrescriberNoteVerticalDisplay;
